import React, { ChangeEvent } from 'react';
import { rootActions, useAppDispatch, useAppSelector } from '../../data/store';

const FormText = () => {

    const dispatch = useAppDispatch();
    const text = useAppSelector(store => store.root.text);

    const updateText = (evt: ChangeEvent<HTMLInputElement>) => {
        dispatch(
            rootActions.main({
                text: evt.target.value,
            })
        )
    };

    return (
        <div className="mr-10 mb-4">
            <label htmlFor="art-text-field" className="mb-2 inline-block">Icons Number</label>

            <input
                id="art-text-field"
                type="text"
                className="w-full border rounded px-4 py-2 block"
                value={ text }
                onChange={ updateText }
                placeholder="Insert Art Text"
            />
        </div>
    )
}

export default FormText;